<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        elevation="2"
        v-bind="attrs"
        v-on="on"
        class="ma-2"
        :title="$t('language.select_language')"
        rounded
      >
        <v-avatar size="18" class="mr-2">
          <v-img :src="languages.find(l => l.code === currentLanguage).flag" />
        </v-avatar>
        <span class="font-weight-bold">{{ languages.find(l => l.code === currentLanguage).name }}</span>
        <v-icon right>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    
    <v-list>
      <v-list-item
        v-for="language in languages"
        :key="language.code"
        @click="changeLanguage(language.code)"
        :class="{ 'v-list-item--active': currentLanguage === language.code }"
      >
        <v-list-item-avatar>
          <v-img :src="language.flag" contain height="20"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ language.name }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="currentLanguage === language.code">
          <v-icon color="primary">fa fa-check</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'LanguageSelector',
  data() {
    return {
      languages: [
        {
          code: 'vi',
          name: 'Tiếng Việt',
          flag: 'https://flagcdn.com/w20/vn.png'
        },
        {
          code: 'zh',
          name: '中文',
          flag: 'https://flagcdn.com/w20/cn.png'
        }
      ]
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale
    }
  },
  methods: {
    changeLanguage(languageCode) {
      this.$i18n.locale = languageCode
      localStorage.setItem('locale', languageCode)
      
      // Reload trang để đảm bảo tất cả component được cập nhật
      this.$nextTick(() => {
        window.location.reload()
      })
    }
  }
}
</script>

<style scoped>
.v-list-item--active {
  background-color: rgba(25, 118, 210, 0.12);
}
</style>